import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PracticeAreasSection } from '../components/PracticeAreasSection';
import { FAQSection } from '../components/FAQSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { DisclaimerModal } from '../components/DisclaimerModal';
import { Toaster } from 'sonner';

export default function HomePage() {
  return (
    <>
      <DisclaimerModal />
      <Toaster position="top-right" richColors />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PracticeAreasSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />

      {/* Page-level Schema Markup */}
      <script type="application/ld+json" className="schema-markup" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Juris Bihar - Chambers of Adv. Ajeet Narayan Sinha",
          "description": "Civil Lawyer in Patna with 35+ years of experience. Legal services for property disputes, civil litigation, and appeals before Patna High Court.",
          "url": typeof window !== 'undefined' ? window.location.origin : "https://jurisbihar.com",
          "mainEntity": {
            "@type": "Attorney",
            "name": "Adv. Ajeet Narayan Sinha",
            "jobTitle": "Civil Lawyer",
            "worksFor": {
              "@type": "LegalService",
              "name": "Juris Bihar"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "306, Devendra Residency, Kankarbagh Main Road",
              "addressLocality": "Patna",
              "addressRegion": "Bihar",
              "postalCode": "800026",
              "addressCountry": "IN"
            }
          }
        })
      }} />
    </>
  );
}
